import React from "react";

const Java_substring = () => {
  return (
    <div>
      <h1>Java substring</h1>
      <p>This page provides explanations, examples, and common use-cases for Java substring in Java.</p>
    </div>
  );
};

export default Java_substring;
